import React from 'react';

import {
  HourglassEmptyOutlined,
  ListOutlined,
  NotificationsNoneOutlined,
  VisibilityOutlined
} from '@mui/icons-material';

export const createStatusItems = ({
  allValue = 'All',
  awaitingLabel,
  awaitingValue,
  notificationLabel,
  notificationValue,
  completedValue = 'Completed'
}) => [
  {
    label: 'All',
    value: allValue,
    icon: <ListOutlined />,
    background: '#F5F5F5',
    activeBackground: '#BDBDBD',
    border: '#D6D6D6',
    activeBorder: '#9E9E9E'
  },
  {
    label: awaitingLabel,
    value: awaitingValue,
    icon: <HourglassEmptyOutlined />,
    background: '#FFEBEE',
    activeBackground: '#FFCDD2',
    border: '#FFD0D8',
    activeBorder: '#EF9A9A'
  },
  {
    label: notificationLabel,
    value: notificationValue,
    icon: <NotificationsNoneOutlined />,
    background: '#E3F2FD',
    activeBackground: '#BBDEFB',
    border: '#BBDEFB',
    activeBorder: '#90CAF9'
  },
  {
    label: 'Completed',
    value: completedValue,
    icon: <VisibilityOutlined />,
    background: '#E8F5E9',
    activeBackground: '#A5D6A7',
    border: '#C8E6C9',
    activeBorder: '#81C784'
  }
];